import $ from "jquery";
import ProductGallery from "@js/product/components/ProductGallery";
function activateFirstProductTab() {
  $(".product-tabs .nav .nav-item:first-child a").tab("show");
}
function handleProductDetailsToggle() {
  const $link = $('[href="#product-details"]');
  const $tab = $($link.attr("href"));
  if ($tab.length && $link.length && $link.hasClass("active")) {
    $tab.addClass("show active");
  }
}
$(() => {
  activateFirstProductTab();
  const gallery = new ProductGallery();
  gallery.init();
  prestashop.on("updatedProductCombination", (event) => {
    gallery.init();
    const { product_add_to_cart: productAddToCart } = event;
    if (productAddToCart) {
      const node = document.createElement("div");
      node.innerHTML = productAddToCart;
      const html = node.querySelector(".js-product-actions-buttons");
      if (html) {
        const productActionsElement = document.querySelector(".js-product-actions-buttons");
        productActionsElement.replaceWith(html);
      }
    }
  });
  prestashop.on("updatedProduct", () => {
    handleProductDetailsToggle();
  });
});
$(function() {
  $('[data-toggle="popover"]').popover();
  $(".share-product-btn").on("click", function() {
    copyAuctionLink(window.location.href, this);
  });
});
function copyAuctionLink(link, element) {
  var tempInput = document.createElement("input");
  tempInput.value = link;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
  $(element).popover("show");
  setTimeout(function() {
    $(element).popover("hide");
  }, 1e3);
}
$(() => {
  if ($("#map").length) {
    let locationDistrict = $("input[name='location-district']").val();
    let map = L.map("map");
    let geocoder = new L.Control.Geocoder.Nominatim();
    var yourQuery = locationDistrict;
    let position = geocoder.geocode(yourQuery, function(results) {
      let latLng = new L.LatLng(results[0].center.lat, results[0].center.lng);
      map.setView(latLng, 11);
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(map);
      var circle = L.circle(latLng, {
        color: "#A0CB2F",
        fillColor: "#A0CB2F",
        fillOpacity: 0.5,
        radius: 7e3
      }).addTo(map);
    });
    $("a[href='#location']").on("shown.bs.tab", function(e) {
      map.invalidateSize();
    });
  }
});
